import { MapView } from '../Map';
import { DateTimeSelector, CompareButton, SankeyButton, DisplayModeSelector } from '../Controls';
import Legend from '../Legend';
import './styles.css';

const MapLayout = () => {
  return (
    <div className="map-layout">
      {/* Full-page map */}
      <div className="map-wrapper">
        <MapView viewId={1} />
      </div>

      {/* Controls overlay */}
      <div className="controls-overlay">
        {/* Top-left: Display mode selector */}
        <div className="control-panel top-left">
          <DisplayModeSelector />
        </div>

        {/* Top-right: Sankey and Compare buttons */}
        <div className="control-panel top-right">
          <div className="top-right-buttons">
            <SankeyButton />
            <CompareButton />
          </div>
        </div>

        {/* Bottom-left: DateTime selector */}
        <div className="control-panel bottom-left">
          <DateTimeSelector viewId={1} />
        </div>

        {/* Bottom-right: Legend */}
        <div className="control-panel bottom-right">
          <Legend />
        </div>
      </div>
    </div>
  );
};

export default MapLayout;
